<template>
    <div class="criteria">
        <div class="criteria__header">
            {{ score.name }}
        </div>
        <div class="criteria__table-wrap">
          <table>
            <tr>
              <th></th>
              <th class="criteria__total">Итоговый балл</th>
              <th v-for="(expert, index) of session.reviewExperts" :key="`column${expert.id}`">Эксперт №{{ index + 1 }}</th>
            </tr>
            <tr v-for="criteria of score.criterias" :key="`row${criteria.id}`">
              <td>
                <div class="criteria__name">{{ criteria.name}}</div>
              </td>
              <td class="criteria__total">
                <div :class="{
                  'criteria__total-wrap': true,
                  'criteria__total-wrap_extended': extended
                }">
                  <div class="criteria__dummy"></div>
                  <div class="criteria__total-value">
                    <div v-if="readonly">{{ scores[criteria.id].score }}</div>
                    <input
                      v-else
                      v-model="scores[criteria.id].score"
                      type="text"
                      :class="{'criteria__total_extended': scores[criteria.id].score.length > 4}"
                    />
                    <span>x{{ criteria.weight }}</span>
                  </div>
                </div>
              </td>
              <td v-for="expert of session.reviewExperts" :key="`cell${criteria.id}-${expert.id}`">
                <div class="criteria__expert-value">
                  <div class="criteria__dummy"></div>
                  <div class="criteria__value">{{ getValue(expert, criteria.id) }}</div>
                  <div class="criteria__dummy"></div>
                </div>
              </td>
            </tr>
          </table>
        </div>
    </div>
</template>

<script>
export default {
    name: "ExpertPanelReviewAssessmentSuperCriteria",
    props: {
        score: Object,
        value: Object,
        session: Object,
        readonly: Boolean,
    },
    computed: {
        total() {
            return Object.keys(this.scores).reduce((result, criteriaId) => {
                const criteria = this.score.criterias.find((criteria) => criteria.id === criteriaId);
                if (criteria) {
                    result += this.scores[criteriaId] * criteria.weight;
                }
                return result;
            }, 0);
        },
        extended() {
            return Object.values(this.scores).find((score) => score.score.length > 4);
        },
    },
    watch: {
        scores: {
            handler() {
                this.$emit('input', this.scores);
            },
            deep: true,
        },
    },
    data() {
        return {
            scores: this.initScores(),
        };
    },
    methods: {
        initScores() {
            return this.score.criterias.reduce((result, criteria) => {
                result[criteria.id] = {
                    score: this.getTotal(criteria.id),
                    weight: criteria.weight,
                };
                return result;
            }, {});
        },
        getValue(expert, criteriaId) {
            return expert.reviewSessions.reduce((result, reviewSession) => {
                const score = reviewSession.reviewSessionScores
                    .find((reviewSessionScore) => reviewSessionScore.reviewScoreId === this.score.id && reviewSessionScore.criteriaId === criteriaId);
                if (score) {
                    return score.score;
                } else {
                    return 0;
                }
            }, 0);
        },
        getTotal(criteriaId) {
            return this.session.reviewExperts.reduce((result, reviewExpert) => {
                result += this.getValue(reviewExpert, criteriaId);
                return result;
            }, 0);
        },
    },
    mounted() {
        const scores = this.initScores();
        if (this.value) {
            this.scores = Object.keys(scores).reduce((result, criteriaId) => {
                if (this.value[criteriaId]) {
                    result[criteriaId] = {
                        ...scores[criteriaId],
                        score: this.value[criteriaId].score,
                    };
                } else {
                    result[criteriaId] = scores[criteriaId];
                }
                return result;
            }, {});
        } else {
            this.scores = scores;
        }
        this.$emit('input', this.scores);
    },
};
</script>

<style lang="scss" scoped>
@import '@/styles/rem';

.criteria {
  font-family: Montserrat, sans-serif;
  &__header {
    font-weight: 600;
    font-size: rem(16);
    line-height: rem(24);
    color: #2A2626;
    margin-bottom: rem(16);
  }
  &__table-wrap {
    max-width: 100%;
    overflow-x: auto;
    &::-webkit-scrollbar {
      height: rem(6);
    }
    &::-webkit-scrollbar-thumb {
      background: #D6E0EA;
      border-radius: rem(20);
    }
    &::-webkit-scrollbar-track {
      background: none;
    }

  }
  table {
    border-spacing: 0;
    border-collapse: separate;
    width: auto;
    table-layout: fixed;
    th {
      font-weight: 600;
      font-size: rem(14);
      line-height: rem(20);
      color: #2A2626;
      padding: 0 rem(8) 0 rem(8);
      text-align: center;
      height: rem(100);
    }
    td {
      font-weight: 400;
      font-size: rem(14);
      line-height: rem(20);
      color: #010101;
      padding: 0;
      border-bottom: solid 1px #D9D9D9;
      text-align: center;
      height: rem(100);
      .criteria__name {
        padding: rem(16) rem(8);
        width: rem(200);
        text-align: left;
        font-weight: 500;
        font-size: rem(14);
        line-height: rem(20);
      }
    }
  }
  &__dummy {
    height: rem(18);
  }
  &__expert-value {
    width: rem(100);
    padding: rem(16) rem(8);
  }
  &__value {
    padding: rem(4) rem(16);
    background: #69609F;
    color: #FFFFFF;
    border-radius: rem(16);
    display: inline-block;
    font-weight: 600;
    font-size: rem(16);
    line-height: rem(22);
    text-align: center;
  }
  &__total-wrap {
    width: rem(100);
    padding: rem(16) rem(8);
    &_extended {
      width: rem(150);
    }
  }
  &__total {
    background: #F6FAFD;
    width: rem(100);
    .criteria__total-value {
      color: #69609F;
      align-items: center;
      padding: 0;
      input, div {
        font-family: Montserrat, sans-serif;
        padding: rem(4) rem(16);
        border: 1px solid #4663AB;
        background: #FFFFFF;
        color: #2A2626;
        border-radius: rem(16);
        font-weight: 600;
        font-size: rem(16);
        line-height: rem(22);
        text-align: center;
      }
      input {
        width: rem(80);
      }
      span {
        display: block;
      }
      div {
        opacity: 0.4;
        display: inline-block;
      }
      input.criteria__total_extended {
        width: rem(120);
      }
    }
  }
}
</style>